/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Hof_Title_LeadInputs */

const en_hof_title_lead = /** @type {(inputs: Hof_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hall of`)
};

const es_hof_title_lead = /** @type {(inputs: Hof_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salón de la`)
};

const de_hof_title_lead = /** @type {(inputs: Hof_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die`)
};

const zh_hof_title_lead = /** @type {(inputs: Hof_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`名人`)
};

const ar_hof_title_lead = /** @type {(inputs: Hof_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`قاعة`)
};

const fr_hof_title_lead = /** @type {(inputs: Hof_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Temple de la`)
};

const vi_hof_title_lead = /** @type {(inputs: Hof_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đại sảnh`)
};

const sw_hof_title_lead = /** @type {(inputs: Hof_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ukumbi wa`)
};

const th_hof_title_lead = /** @type {(inputs: Hof_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`หอ`)
};

const bs_hof_title_lead = /** @type {(inputs: Hof_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kuća`)
};

const ja_hof_title_lead = /** @type {(inputs: Hof_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ホール・オブ・`)
};

const ko_hof_title_lead = /** @type {(inputs: Hof_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`명예의`)
};

const pt_hof_title_lead = /** @type {(inputs: Hof_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hall da`)
};

const it_hof_title_lead = /** @type {(inputs: Hof_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hall of`)
};

const sv_hof_title_lead = /** @type {(inputs: Hof_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hall of`)
};

const nl_hof_title_lead = /** @type {(inputs: Hof_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`De`)
};

const da_hof_title_lead = /** @type {(inputs: Hof_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hall of`)
};

const nb_hof_title_lead = /** @type {(inputs: Hof_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hall of`)
};

const fi_hof_title_lead = /** @type {(inputs: Hof_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Markin`)
};

const pl_hof_title_lead = /** @type {(inputs: Hof_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Galeria`)
};

const ru_hof_title_lead = /** @type {(inputs: Hof_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Зал`)
};

const tr_hof_title_lead = /** @type {(inputs: Hof_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Şöhretler`)
};

const hi_hof_title_lead = /** @type {(inputs: Hof_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`हॉल ऑफ`)
};

const id_hof_title_lead = /** @type {(inputs: Hof_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Balai`)
};

const ms_hof_title_lead = /** @type {(inputs: Hof_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dewan`)
};

const cs_hof_title_lead = /** @type {(inputs: Hof_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Síň`)
};

const el_hof_title_lead = /** @type {(inputs: Hof_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Πάνθεον`)
};

const he_hof_title_lead = /** @type {(inputs: Hof_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`היכל`)
};

const af_hof_title_lead = /** @type {(inputs: Hof_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die`)
};

const hu_hof_title_lead = /** @type {(inputs: Hof_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hírességek`)
};

/**
* | output |
* | --- |
* | "Hall of" |
*
* @param {Hof_Title_LeadInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const hof_title_lead = /** @type {((inputs?: Hof_Title_LeadInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Hof_Title_LeadInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_hof_title_lead(inputs)
	if (locale === "de") return de_hof_title_lead(inputs)
	if (locale === "zh") return zh_hof_title_lead(inputs)
	if (locale === "ar") return ar_hof_title_lead(inputs)
	if (locale === "fr") return fr_hof_title_lead(inputs)
	if (locale === "vi") return vi_hof_title_lead(inputs)
	if (locale === "sw") return sw_hof_title_lead(inputs)
	if (locale === "th") return th_hof_title_lead(inputs)
	if (locale === "bs") return bs_hof_title_lead(inputs)
	if (locale === "ja") return ja_hof_title_lead(inputs)
	if (locale === "ko") return ko_hof_title_lead(inputs)
	if (locale === "pt") return pt_hof_title_lead(inputs)
	if (locale === "it") return it_hof_title_lead(inputs)
	if (locale === "sv") return sv_hof_title_lead(inputs)
	if (locale === "nl") return nl_hof_title_lead(inputs)
	if (locale === "da") return da_hof_title_lead(inputs)
	if (locale === "nb") return nb_hof_title_lead(inputs)
	if (locale === "fi") return fi_hof_title_lead(inputs)
	if (locale === "pl") return pl_hof_title_lead(inputs)
	if (locale === "ru") return ru_hof_title_lead(inputs)
	if (locale === "tr") return tr_hof_title_lead(inputs)
	if (locale === "hi") return hi_hof_title_lead(inputs)
	if (locale === "id") return id_hof_title_lead(inputs)
	if (locale === "ms") return ms_hof_title_lead(inputs)
	if (locale === "cs") return cs_hof_title_lead(inputs)
	if (locale === "el") return el_hof_title_lead(inputs)
	if (locale === "he") return he_hof_title_lead(inputs)
	if (locale === "af") return af_hof_title_lead(inputs)
	if (locale === "hu") return hu_hof_title_lead(inputs)
	return en_hof_title_lead(inputs)
});